import './Footer.css';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner">
                <span className="footer-copy">© {year} 尛尛居落工具箱</span>
                <a
                    href="https://beian.miit.gov.cn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="beian-link"
                >
                    京ICP备 2021025485号-1
                </a>
            </div>
        </footer>
    );
};

export default Footer;
